import React, { useEffect, useRef } from 'react';
import useStyles from './useStyles';
import PropTypes from 'prop-types';
import moment from 'moment';
import ChatItem from './components/ChatItem';
import SmsRoundedIcon from '@mui/icons-material/SmsRounded';

function ChatWindow({ conversation, body, signature }) {
  const root = useRef(null);

  useEffect(() => {
    root.current.scrollTop = root.current.scrollHeight + 20;
  }, [conversation, body, signature]);

  const classes = useStyles();

  return (
    <div ref={root} className={classes.root}>
      {conversation.length > 1 ? (
        <div className={classes.noMessages}>
          <SmsRoundedIcon />
          <span>Send a group message</span>
        </div>
      ) : conversation[0].messages.length <= 0 ? (
        <div className={classes.noMessages}>
          <SmsRoundedIcon />
          <span>This conversation is empty</span>
        </div>
      ) : (
        <div className={classes.chatContainer}>
          {conversation[0].messages.map((message, i) =>
            message &&
            conversation[0].messages[i + 1] &&
            moment
              .duration(
                moment(message.sent_time).diff(moment(conversation[0].messages[i + 1].sent_time))
              )
              .asHours() > 1 ? (
              <ChatItem key={message.id} message={message} />
            ) : (
              <div key={message.id} style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={classes.timestamp}>
                  {message.sent_time && moment(message.sent_time).format('h:mma')}
                </div>
                <ChatItem message={message} />
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

ChatWindow.propTypes = {
  conversation: PropTypes.array.isRequired,
  body: PropTypes.string,
  signature: PropTypes.string
};

export default ChatWindow;
